import axios from 'axios';
import { isObjectValidAndNotEmpty } from '../../constants/nullCheckUtils';
import { hideSpinner, showSpinner } from '../../redux/modules/spinner/spinner';
import api from '../../constants/api';
import { apiCatchBlockFunction } from '../../constants/CommonUtil';

const fetchPartnerDto = async (payer, dispatcher) => {
    if (isObjectValidAndNotEmpty(payer) && payer.key) {
        try {
            dispatcher(showSpinner());
            const response = await axios.get(`${api.CLAIMS.GET_PARTNER_DTO_FOR_PAYER}?payerUuid=${payer.key}`);
            dispatcher(hideSpinner());
            return response.data;
        } catch (e) {
            apiCatchBlockFunction(e, dispatcher);
            return null;
        }
    }
    return null;
};

export default fetchPartnerDto;
